export default __webpack_public_path__ + "static/media/lab-list-header-bg.5ae66786.png";